<template>
  <div>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
      :property-mapping="errorPropertyMappings"
    />
    <u-loader v-if="isLoading" />
    <div v-else>
      <div class="row">
        <div class="col-3 font-weight-bold">
          Feiertagskalender verwenden
        </div>
        <div class="col-9">
          <label>
            <input
              v-model="configuration.useGlobalerFeiertagskalender"
              :disabled="!canUserEdit"
              name="check"
              type="checkbox"
            >
            <span class="label-text" />
          </label>
        </div>
      </div>

      <div class="row">
        <div class="col-3 font-weight-bold">
          Gesetzlicher Mindestlohn überprüfen
        </div>
        <div class="col-9">
          <label>
            <input
              v-model="configuration.gesetzlicherMindestlohnCheckEnabled"
              :disabled="!canUserEdit"
              name="check"
              type="checkbox"
            >
            <span class="label-text" />
          </label>
        </div>
      </div>
      <div class="row">
        <div class="col-3 mt-2 font-weight-bold">
          Berechnungsart Ferien
        </div>
        <div class="col-4">
          <v-select
            v-model="configuration.vacationCalculationType"
            :disabled="!canUserEdit"
            :items="calculationTypes"
            item-text="name"
            item-value="value"
            label="Berechnungsart Ferien"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-3 mt-2 font-weight-bold">
          Berechnungsart Feiertage
        </div>
        <div class="col-4">
          <v-select
            v-model="configuration.holidayCalculationType"
            :disabled="!canUserEdit"
            :items="calculationTypes"
            item-text="name"
            item-value="value"
            label="Berechnungsart Feiertage"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-3 mt-2 font-weight-bold">
          13. Monatslohn Berechnungstyp
        </div>
        <div class="col-4">
          <v-select
            v-model="configuration.month13SalaryCalculationType"
            :disabled="!canUserEdit"
            :items="calculationTypes"
            item-text="name"
            item-value="value"
            label="13. Monatslohn Berechnungstyp"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-3 mt-2 font-weight-bold">
          Berechnungsart FAR
        </div>
        <div class="col-4">
          <v-select
            v-model="configuration.farCalculationType"
            :disabled="!canUserEdit"
            :items="farCalculationTypes"
            item-text="text"
            item-value="value"
            label="Berechnungsart FAR"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-3 font-weight-bold">
          Qualifikationsstufen verwenden
        </div>
        <div class="col-9">
          <label>
            <input
              v-model="configuration.qualificationLevelEnabled"
              :disabled="!canUserEdit"
              name="check"
              type="checkbox"
            >
            <span class="label-text" />
          </label>
        </div>
      </div>
      <div class="row">
        <v-alert
          :value="showHolidayChangedAlert"
          type="info"
          dismissible
          class="ml-1"
        >
          Die Arbeitstage wurden auf "Montag bis Freitag" gesetzt. Falls dies
          nicht zutrifft, bitte unter "Feiertage > Definition der Arbeitstage"
          anpassen
        </v-alert>
      </div>
      <div class="mt-4">
        <b-button
          v-if="canUserEdit"
          variant="success"
          @click="saveConfiguration()"
        >
          Speichern
        </b-button>
        <b-button
          v-if="canUserEdit"
          class="ml-2"
          variant="danger"
          @click="getAllConfigurations()"
        >
          Abbrechen
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetConfiguration,
  SaveConfiguration,
  GetFARCalculationType,
} from "@/services/minimum.wage.services/configuration.minimum.wages.js";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";

export default {
  mixins: [MinimumWageMixin],
  data() {
    return {
      isLoading: false,
      errorObject: null,
      configuration: null,
      calculationTypes: [
        { value: 1, name: "Basis (1)" },
        { value: 2, name: "Basis & Ferien (2)" },
        { value: 3, name: "Basis & Feiertage (3)" },
        { value: 4, name: "Basis & Ferien & Feiertage (4)" },
        { value: 5, name: "Basis & Ferien & 13ML (5)" },
        { value: 6, name: "Basis & Feiertage & 13 ML (6)" },
        { value: 7, name: "Basis & 13 ML (7)" },
        { value: 8, name: "Basis & Ferien & Feiertage & 13 ML (8)" },
        { value: 9, name: "kein 13 ML (9)" },
      ],
      years: [{ text: "Jahr aus Konfig verwenden", value: null }],
      cantons: [
        { text: "Kanton aus Konfig verwenden", value: null },
        { text: "AG", value: "AG" },
        { text: "AI", value: "AI" },
        { text: "AR", value: "AR" },
        { text: "BL", value: "BL" },
        { text: "BS", value: "BS" },
        { text: "BE", value: "BE" },
        { text: "FR", value: "FR" },
        { text: "GE", value: "GE" },
        { text: "GL", value: "GL" },
        { text: "GR", value: "GR" },
        { text: "JU", value: "JU" },
        { text: "NE", value: "NE" },
        { text: "NW", value: "NW" },
        { text: "OW", value: "OW" },
        { text: "SH", value: "SH" },
        { text: "SO", value: "SO" },
        { text: "SG", value: "SG" },
        { text: "SZ", value: "SZ" },
        { text: "TI", value: "TI" },
        { text: "TG", value: "TG" },
        { text: "UR", value: "UR" },
        { text: "VD", value: "VD" },
        { text: "VS", value: "VS" },
        { text: "ZG", value: "ZG" },
        { text: "ZH", value: "ZH" },
      ],
      farCalculationTypes: [],
      showHolidayChangedAlert: false,
    };
  },

  created() {
    this.getFARCalculationType();
    this.getAllConfigurations();
    for (var year = 2005; year < 2050; year++) {
      this.years.push({ text: `${year}`, value: `${year}` });
    }
  },
  methods: {
    getFARCalculationType() {
      this.isLoading = true;
      this.errorObject = null;

      GetFARCalculationType(
        (response) => {
          const farCalculationTypes = JSON.parse(JSON.stringify(response));

          Object.keys(farCalculationTypes).forEach((key) => {
            this.farCalculationTypes.push({
              value: parseInt(key),
              text: farCalculationTypes[key],
            });
          });

          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    getAllConfigurations() {
      this.isLoading = true;
      this.errorObject = null;

      GetConfiguration(
        this.contractId,
        this.versionId,
        this.editionId,
        (response) => {
          this.configuration = JSON.parse(JSON.stringify(response));
          this.$store.commit(
            "setConfiguration",
            JSON.parse(JSON.stringify(response)),
          );
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    saveConfiguration() {
      this.isLoading = true;
      this.errorObject = null;

      SaveConfiguration(
        this.contractId,
        this.versionId,
        this.editionId,
        this.configuration,
        (response) => {
          console.log(
            JSON.parse(JSON.stringify(response)),
            this.showHolidayChangedAlert,
          );
          if (response.configPublicHolidaysChanged) {
            this.showHolidayChangedAlert = true;
          } else {
            this.showHolidayChangedAlert = false;
          }
          this.getAllConfigurations();
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
  },
};
</script>

<style scoped></style>
